module.exports = __webpack_public_path__ + "img/image32.5328407d.png";